export default __webpack_public_path__ + "static/media/flower.727889eb.png";